<template>
  <div class="login" @keyup.enter="Login">
    <el-card class="signBox">
      <el-form
        class="demo-ruleForm"
        v-bind:model="ruleForm"
        status-icon=""
        v-bind:rules="rules"
        ref="form"
        label-width="0px"
      >
        <el-form-item label="" prop="cellphone">
          <span>{{ $t('login.userName') }}</span>
          <el-input
            type="text"
            v-model="ruleForm.cellphone"
            autocomplete="off"
            :placeholder="$t('login.enterName')"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <span>{{ $t('login.password') }}</span>
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            :placeholder="$t('login.enterPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            style="width: 100%; margin-top: 20px"
            @click="Login"
          >
            {{ $t('login.login') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>

import md5 from "md5";
import Cookies from "js-cookie";
import CryptoJS from 'crypto-js'

export default {
  name: 'Login',
  data() {
    const validateCellphone = (rule, value, callback) => {
      if (value) callback()
      else callback(new Error(this.$t('login.enterName') + '!'))
    }

    const validatePassword = (rule, value, callback) => {
      if (value) callback()
      else callback(new Error(this.$t('login.enterPassword') + '!'))
    }

    let cellphone = ''

    return {
      ruleForm: {cellphone, password: ''},
      rules: {
        cellphone: [{validator: validateCellphone, trigger: 'blur'}],
        password: [{validator: validatePassword, trigger: 'blur'}]
      }
    }
  },
  mounted() {
    // console.log(this.$router.options.routes.filter(i=>i.path==='/')[0].children.filter(i=>i.name))
  },
  methods: {
    getFirstMenuKey(menu) {
      if (menu.hasSubMenu) {
        return menu.subMenuList[0].url + '***' + menu.subMenuList[0].menuCode
      } else {
        return menu.url + '***' + menu.menuCode
      }
    },
    LoginElearning() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // let password = md5(this.ruleForm.password);
          let password = CryptoJS.SHA256(md5(this.ruleForm.password)).toString()
          let ruleForm = {...this.ruleForm, password};
          let data = await window.instance.post(commonServer + "account/login", ruleForm)

          data = data.data
          let menuMap = {};
          console.log('data.data.menuList', data.data.menuList)
          _.each(data.data.menuList, (menu) => {
            menuMap[menu.url] = menu.menuCode;
            if (menu.hasSubMenu) {
              _.each(menu.subMenuList, (subMenu => {
                menuMap[subMenu.url] = subMenu.menuCode;
              }))
            }
          })
          localStorage.setItem("elearningMenuData", JSON.stringify(data.data.menuList))
          localStorage.setItem("elearningMenuMap", JSON.stringify(menuMap))
          localStorage.cellphone = ruleForm.cellphone;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    LoginPublic() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let password = md5(this.ruleForm.password);
          let ruleForm = {...this.ruleForm, password};
          let LoginResult = await window.instance.post(pubServer + "/account/login", ruleForm)
          LoginResult = LoginResult.data;
          localStorage.setItem("menuDataPublicServer", JSON.stringify(LoginResult.data.menuList))
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async LoginTopDoor() {
      const params = {
        "appName": "top_door",
        "cellphone": this.ruleForm.cellphone,
        "password": md5(this.ruleForm.password),
        "platform": "H5"
      }
      let res = await window.instance.post(window.retailinkUrl + '/accounts/login', params)
      let menuTitleMap = {};
      res = res.data.data
      const account = res.account
      const menuList = res.menuList
      localStorage.setItem("topdoorMenus", JSON.stringify(menuList))
    },

    async LoginOpr() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // let password = md5(this.ruleForm.password);
          let password = CryptoJS.SHA256(md5(this.ruleForm.password)).toString()
          let ruleForm = {...this.ruleForm, password};
          let LoginResult = await axios.post(oprReqUrl + "account/login", ruleForm);
          LoginResult = LoginResult.data;
          if (LoginResult.code !== 200) {
            this.$message.warning(LoginResult.message)
            return false;
          }
          this.$store.commit("setToken", LoginResult.data.token);
          this.$store.commit("setAccount", LoginResult.data.Account.ccount);
          localStorage.cellphone = ruleForm.cellphone;
          localStorage.remember = this.remember;
          // LoginResult.data.menuList
          localStorage.setItem("oprMenuData", JSON.stringify(LoginResult.data.menuList))
          localStorage.setItem("menuViewData", LoginResult.data.reportFlag)
          localStorage.setItem("userName", LoginResult.data.Account.name)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async LoginOpenSurvey() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let password = this.ruleForm.password
          let ruleForm = {...this.ruleForm, password}
          let {data} = await window.instance.post(openSurveyReqUrl + 'account/login', ruleForm)

          if (data.code === 200) {
            this.$store.commit('setToken', data.data.token)
            this.$store.commit('setAccount', data.data.cellphone)
            this.$store.commit('setRoleCode', data.data.role)
            this.$store.commit('setAdmin', data.data.role.toUpperCase() === 'ADMIN' || data.data.role.toUpperCase() === 'NIKEINTERNALMM')
            this.$store.commit('setOthers', data.data.role.toUpperCase() === 'OTHERS')
            this.$store.commit('setHead', data.data.role.toUpperCase() === 'HEADQUARTER' || data.data.role.toUpperCase() === 'NIKEINTERNALCLIENT')
            localStorage.setItem('userName', data.data.name)
            localStorage.setItem('account', data.data.account)
            localStorage.setItem('roleCode', data.data.role)
            localStorage.setItem('isAdmin', data.data.role.toUpperCase() === 'ADMIN' || data.data.role.toUpperCase() === 'NIKEINTERNALMM')
            localStorage.setItem('isOthers', data.data.role.toUpperCase() === 'OTHERS')
            localStorage.setItem('isHead', data.data.role.toUpperCase() === 'HEADQUARTER' || data.data.role.toUpperCase() === 'NIKEINTERNALCLIENT')
          }
          if (data.code !== 200) {
            this.$message.warning(data.message)
            return false
          }
          // this.$router.push('/newSurvey')
          Cookies.set('menuTitle', '/newSurvey?published=1')
        } else {
          return false
        }
      })
    },

    async LoginVms() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let password = md5(this.ruleForm.password);
          let ruleForm = {...this.ruleForm, password};
          let LoginResult = await axios.post(vmsReqUrl + "account/login", ruleForm);
          LoginResult = LoginResult.data;
          console.log('vms.login.LoginResult:' + LoginResult)
          if (LoginResult.code !== 200) {
            // this.$message.warning(LoginResult.message)
            // return false;
          } else {
            this.$store.commit("setToken", LoginResult.data.token);
            // this.$store.commit("setAccount", LoginResult.data.Account.account);
            localStorage.setItem("vmsMenuData", JSON.stringify(LoginResult.data.menuList))
            localStorage.setItem("userName", LoginResult.data.Account.name)
            localStorage.cellphone = ruleForm.cellphone;
            localStorage.remember = this.remember;
            // this.$router.push("/pages/home");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async Login() {
      // todo: sha256加密
      // let password = CryptoJS.SHA256(md5(this.ruleForm.password)).toString()
      // console.log('password', password)
      const params = {
        "appName": "retail_ink",
        "cellphone": this.ruleForm.cellphone,
        "password": md5(this.ruleForm.password),
        "platform": "H5"
      }
      let res = await window.instance.post(window.retailinkUrl + '/accounts/login', params)
      if (res.data.code === 200) {
        res = res.data.data
        const account = res.account
        const menuList = res.menuList
        const leftMenus = res.leftMenus
        const rightMenus = res.rightMenus
        const subSystemMenuMap = res.subSystemMenuMap
        console.log('menuList', menuList)
        // if (!menuList || !menuList.length) {
        // this.$message.error('没有配置菜单权限');
        // return false;
        // }
        // 保存opr菜单和角色(opr项目暂未用到roleCode)
        if (subSystemMenuMap && subSystemMenuMap.opr) {
          localStorage.setItem("oprMenuData", JSON.stringify(subSystemMenuMap.opr))
        }

        if (subSystemMenuMap && subSystemMenuMap.vms) {
          // 保存vms菜单和角色(vms项目暂未用到roleCode)
          localStorage.setItem("vmsMenuData", JSON.stringify(subSystemMenuMap.vms))
        }

        // 保存wo菜单和角色
        if (subSystemMenuMap && subSystemMenuMap.wo) {
          Cookies.set('wo-menu', JSON.stringify(subSystemMenuMap.wo))
        }

        if (res.scope.wo) {
          Cookies.set('wo-role-code', res.scope.wo)
        }

        // 保存retailLog菜单和角色
        let retailLogMenuTitleMap = {};
        if (subSystemMenuMap && subSystemMenuMap.retailLog) {
          _.each(subSystemMenuMap.retailLog, (menu) => {
            retailLogMenuTitleMap[menu.url] = menu.menuName;
            if (menu.hasSubMenu) {
              _.each(menu.subMenuList, (subMenu => {
                retailLogMenuTitleMap[subMenu.url] = subMenu.menuName;
              }))
            }
          })
          localStorage.setItem("retailogMenus", JSON.stringify(subSystemMenuMap.retailLog))
          localStorage.setItem("retailogMenuTitleMap", JSON.stringify(retailLogMenuTitleMap))
        }
        if (res.scope.retail_log) {
          Cookies.set('retailog-roleCode', res.scope.retail_log)
        }

        // 保存listenU相关的数据
        //if (res.scope.listen_u && res.listenMenus && res.listenUPermission) {
        //  this.setListenUData(res.scope.listen_u, res.account, res.listenMenus, res.listenUPermission)
        //}


        console.log('data.data.menuList', menuList)
        // todo: 保存每个mune的menuCode,后面可能会用到,暂时没用
        let menuMap = {};
        _.each(menuList, (menu) => {
          menuMap[menu.url] = menu.menuCode;
          if (menu.hasSubMenu) {
            _.each(menu.subMenuList, (subMenu => {
              menuMap[subMenu.url] = subMenu.menuCode;
            }))
          }
        })
        // 保存每个mune的title,在页面上显示
        let menuTitleMap = {};
        _.each(menuList, (menu) => {
          menuTitleMap[menu.url] = menu.menuName;
          if (menu.hasSubMenu) {
            _.each(menu.subMenuList, (subMenu => {
              menuTitleMap[subMenu.url] = subMenu.menuName;
            }))
          }
        })
        localStorage.setItem("leftMenus", JSON.stringify(leftMenus))
        localStorage.setItem("rightMenus", JSON.stringify(rightMenus))
        localStorage.setItem("retailinkMenus", JSON.stringify(menuList))
        localStorage.setItem("retailinkMenuMap", JSON.stringify(menuMap))
        localStorage.setItem("retailinkMenuTitleMap", JSON.stringify(menuTitleMap))
        // const indexMenu = this.getFirstMenuKey(menuList[0])
        // console.log('getFirstMenuKey', indexMenu)
        this.$store.commit("setToken", res.token);
        this.$store.commit("setAccount", account.cellphone);
        this.$store.commit("setAvatar", account.imageUrl);
        this.$store.commit("setRoleCode", account.roleCode);
        localStorage.setItem("userName", account.name);
        localStorage.setItem("roleName", account.roleName);
        localStorage.setItem("account", account.account);
        localStorage.setItem("avatar", account.imageUrl);
        console.log('this.$store.getters.retailinkMenuHighLight', this.$store.getters.retailinkMenuHighLight)
        // let currentPage = this.$store.getters.retailinkMenuHighLight || indexMenu
        let currentPage = this.$store.getters.retailinkMenuHighLight || ''
        console.log('currentPage', currentPage)
        let [menuKey, menuCode] = currentPage.split('***');
        // this.$router.push({path: menuKey, query: { menuCode: menuCode }});
        this.$router.push({path: 'desktop', query: {menuCode: menuCode}});

        if (subSystemMenuMap && subSystemMenuMap.elearning) {
          this.LoginElearning();
        }
        if (subSystemMenuMap && subSystemMenuMap.public) {
          this.LoginPublic();
        }
        if (subSystemMenuMap && subSystemMenuMap.top_door) {
          this.LoginTopDoor();
        }
        if (subSystemMenuMap && subSystemMenuMap.opr) {
          this.LoginOpr();
        }
        if (subSystemMenuMap && subSystemMenuMap.vms) {
          this.LoginVms();
        }
        if (subSystemMenuMap && subSystemMenuMap.open_survey) {
          this.LoginOpenSurvey();
        }
      }
    },
    getListenUFirstMenuKey(menu) {
      if (menu.child && menu.child.length) {
        return menu.child[0].route
      } else {
        return menu.route
      }
    },
    setListenUData(roleCode, account, menu, permission) {
      // 信息
      localStorage.setItem('listen-roleCode', roleCode)
      localStorage.setItem('listen-isAdmin', roleCode.toUpperCase() === 'ADMIN' || roleCode.toUpperCase() === 'NIKEINTERNALMM')
      localStorage.setItem('listen-isOthers', roleCode.toUpperCase() === 'OTHERS')
      localStorage.setItem('listen-isHead', roleCode.toUpperCase() === 'HEADQUARTER' || roleCode.toUpperCase() === 'NIKEINTERNALCLIENT')

      // 菜单
      const indexMenu = this.getListenUFirstMenuKey(menu[0])
      localStorage.cellphone = account.cellphone
      // localStorage.remember = this.remember || false;
      const {statementNational, statementRegion, statementCity, statementSingleStore} = permission
      const isSecond = !statementNational && statementRegion // 是二级页面
      const isThird = (!statementRegion && statementCity) // 是三级页面
      const isFourth = (!statementCity && statementSingleStore) // 是四级页面
      console.log('getFirstMenuKey', indexMenu)
      Cookies.set('listen-menuTitle', indexMenu)
      const menus = menu
      const initDate = this.$tool.getCurrentMonth()
      let startTime = initDate.startTime
      let endTime = initDate.endTime
      const dateQueries = '&dateType=month&startTime=' + startTime + '&endTime=' + endTime
      if (isSecond) {
        menus[0].route = menus[0].route + '?isSecond=true&regionNo=' + account.regionNo + '&regionName=' + account.regionName + dateQueries
      }
      if (isThird) {
        menus[0].route = menus[0].route + '?isThird=true&regionNo=' + account.regionNo + '&regionName=' + account.regionName + '&cityNo=' + account.cityNo + '&cityName=' + account.cityName + dateQueries
      }
      if (isFourth) {
        menus[0].route = menus[0].route + '?posId=' + account.posId + '&doorName=' + account.doorName + dateQueries
      }
      console.log('menu', JSON.stringify(menus))
      localStorage.setItem('surveyMenuData', JSON.stringify(menus))
    }
  }
}
</script>

<style scoped lang="scss">
.login {
  height: 100vh;
  width: 100vw;
  background: #EEEEEE;
  overflow: hidden;

  .topBar {
    display: flex;
    height: 40px;
    padding: 15px;
    align-items: center;
    flex-direction: row-reverse;
  }

  .signBox {
    width: 360px;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      color: #6F6F6F;
      font-size: 26px;
      font-weight: 600;
      letter-spacing: 2px;
      text-align: center;
      margin-bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue